import React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import clsx from 'clsx'

import styles from './Button.module.scss'

interface ButtonWrapperProps extends ButtonProps {
  align?: 'center' | 'start' | 'end'
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = (
  props: ButtonWrapperProps
) => {
  const { children, className, align = 'center', ...muiProps } = props
  return (
    <Button
      className={clsx(styles.buttonRoot, className)}
      sx={{
        '&.MuiButton-text': {
          // textDecoration: 'underline',
        },
        '&.Mui-disabled': {
          color: '#777',
          textDecoration: 'none',
        },
        alignSelf:
          align === 'start'
            ? 'flex-start'
            : align === 'end'
              ? 'flex-end'
              : 'center',
      }}
      {...muiProps}
    >
      {children}
    </Button>
  )
}

export default ButtonWrapper
